import { IdIdentifier, Timestamps, UserIdentifier } from '../common';
import { MotionType } from './motions';
import { SceneItem } from './scene-item';

export type Scene = IdIdentifier &
  Timestamps &
  UserIdentifier & {
    name?: string;
    videoId: string;
    index: number;
    text: string;
    items: SceneItem[];
    duration: number;
    customDuration?: boolean;
    musicMigrated?: boolean;
  };

export interface SceneWord {
  word: string;
  start: number;
  end: number;
}

export enum TransitionEffect {
  None = 'none',
  Fade = 'fade',
  Slide = 'slide',
  Wipe = 'wipe',
  Flip = 'flip',
  ClockWipe = 'clockWipe',
  ClockWise = 'clock-wise',
  TestGL = 'test-gl',
  PullIn = 'pull-in',
  ZoomIn = 'zoom-in',
}

export const GLOBAL_SCENE_INDEX = -1;
